import { writable } from "svelte/store";

export const authUI = writable(undefined);
export const loggedUser = writable(null);

export const role = writable("user");
export const token = writable("");